module.exports = __webpack_public_path__ + "static/gallery-2-2a8ee2e90acae9cca62c10f2a791e023.png";